// extracted by mini-css-extract-plugin
export default {"list":"priceDetails-module__list__o5fvT"};